import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';

let client: SupabaseClient | null = null;

/** Единственный клиент Supabase. Только publishable (anon) ключ; права — через RLS и GRANT. */
export function supabase(): SupabaseClient {
  if (!env) throw new Error('Supabase не настроен');
  client ??= createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'studio-owner-auth',
    },
  });
  return client;
}

export function mediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  // Фото из конфига — статика студии (/s/{slug}/media/…); загрузки владельца — Storage
  if (path.startsWith('/') || /^https?:\/\//.test(path)) return path;
  if (!env) return null;
  return `${env.VITE_SUPABASE_URL}/storage/v1/object/public/tenant-media/${path
    .split('/')
    .map(encodeURIComponent)
    .join('/')}`;
}
